import type { SortDirection } from "../components/ListTable";
import { navigate, useCurrentUrl } from "../lib/urls";
import type { RouteNode } from "../lib/urls/types";

type SortableRoute = RouteNode & { pattern: `${string}sort=:sort${string}` };

export function useUrlSort<C extends string>(
  scope: SortableRoute,
  columns: Record<C, SortDirection>
) {
  const { sort, dir } = useCurrentUrl(scope) as { sort?: string; dir?: string };
  const sortColumn = sort !== undefined && sort in columns ? (sort as C) : null;
  const sortDirection: SortDirection =
    dir === "asc" || dir === "desc"
      ? dir
      : sortColumn
        ? columns[sortColumn]
        : "desc";
  const setSort = (column: C) => {
    navigate(null, { sort: column, dir: columns[column] }, { replace: true });
  };
  const handleSort = (column: string) => {
    if (column === sortColumn) {
      navigate(
        null,
        { dir: sortDirection === "asc" ? "desc" : "asc" },
        { replace: true }
      );
    } else {
      setSort(column as C);
    }
  };
  const sortableColumns = Object.keys(columns);
  return { sortColumn, sortDirection, setSort, handleSort, sortableColumns };
}
